// 后端通过网站模板接口 resultData.frontendFeatures 下发；未配置时均关闭。
export const DEFAULT_WEBSITE_FEATURES = Object.freeze({
  topCompanyLoginEnabled: false,
  serviceIntegrationEnabled: false,
  operationGuideWebsiteEnabled: false,
  operationGuideServicePlatformEnabled: false
})

export function normalizeWebsiteFeatures(value) {
  let config = value
  if (typeof config === 'string') {
    try {
      config = JSON.parse(config)
    } catch (error) {
      config = null
    }
  }
  const isEnabled = flag => flag === true || flag === 1 || flag === '1' || flag === 'true'
  return {
    topCompanyLoginEnabled: isEnabled(config?.topCompanyLoginEnabled),
    serviceIntegrationEnabled: isEnabled(config?.serviceIntegrationEnabled),
    // 新开关仅接受后端明确的布尔值，未下发、缺失或格式异常均保持关闭。
    operationGuideWebsiteEnabled: config?.operationGuideWebsiteEnabled === true,
    operationGuideServicePlatformEnabled: config?.operationGuideServicePlatformEnabled === true
  }
}
